import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent implements OnInit {

  @Input() steps: { title: string; id: string }[] = [];
  @Output() activeStepChange = new EventEmitter<number>();
  @Input() localize: boolean;

  activeStep = 0;

  constructor() {
    this.activeStepChange.emit(0);
  }

  ngOnInit(): void {
  }

  changeStep(step: number): void {
    this.activeStep = step;
    this.activeStepChange.emit(step);
  }

}
